<template>
  <div class="main-cn">
    <div class="main-hd">
      <h4>创建用户</h4>
    </div>
    <div class="main-bd mg20">
      <el-row>
        <el-col :span="12">
          <sub-form :model="user" :scenario="'create'" @submit="submitForm($event)"></sub-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import UserService from "~/services/user";
import subForm from "~/views/user/form.vue";

export default {
    components: {
        subForm
    },

    data() {
        return {
            user: null,
        };
    },

    created() {
        this.user = UserService.getModel();
    },

    methods: {
        submitForm(user) {
            UserService.create(user).then(res => {
                if (res.code == 0) {
                    let user = res.data;
                    this.$message({
                        message: "保存成功!",
                        type: "success",
                        showClose: true,
                    });

                    this.$router.push({
                        path: "/users/view",
                        query: {
                            id: user.id
                        }
                    });
                }
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/views/user/create.vue